// Extension point used by the inbox-creation UI so downstream installations
// (e.g. the `custom/` overlay) can register new channels without modifying
// upstream Vue files.
//
// Registrations should run as side effects of importing files under
// `custom/app/javascript/dashboard/channels/registrations/*.js`; the
// dashboard entrypoint pulls those in via `import.meta.glob` so the order
// of evaluation is deterministic and finishes before any settings page is
// rendered.

const formComponents = {};
const listEntries = [];
const listTabsRegistry = {};
const settingsTabsRegistry = {};

export const customChannels = {
  registerFormComponent(key, component) {
    formComponents[key] = component;
  },
  registerListEntry(entry) {
    listEntries.push(entry);
  },
  // Channel-specific list tabs (replaces the OSS "Mine / Unassigned / All"
  // assignee tabs in `ChatList.vue` when the active inbox matches).
  // `factory(ctx)` receives `{ t, getters }` and must return an array of
  // `{ key, name, count }` objects.
  registerListTabs(channelType, factory) {
    listTabsRegistry[channelType] = factory;
  },
  // Channel-specific settings tabs (spread into the `tabs()` computed in
  // `Settings.vue`). `descriptor = { key, label, component }`.
  registerSettingsTab(channelType, descriptor) {
    (settingsTabsRegistry[channelType] ||= []).push(descriptor);
  },
  formComponents() {
    return { ...formComponents };
  },
  listEntries() {
    return [...listEntries];
  },
  listTabs(channelType, ctx) {
    return listTabsRegistry[channelType]?.(ctx) ?? null;
  },
  settingsTabsFor(channelType) {
    return [...(settingsTabsRegistry[channelType] || [])];
  },
};
